import { appConstants } from '../../../constants'

const initialState = {
  list: {},
  loading: true,
  activeDisable: true,
  error: null
}

export const reducerListVotes = (state = initialState, action) => {
  switch (action.type){
    case appConstants.GET_LIST_VOTE_SUCCESS :
      return {
        ...state,
        loading: false,
        list: action.payload.dataVote
      }
    case appConstants.GET_LIST_VOTE_REQUEST :
      return {
        ...state,
        loading: true
      }
    case appConstants.GET_LIST_VOTE_FAILED :
      return {
        ...state,
        error: { ...action.payload.message }
      }
    default : 
      return state
  }
}
